(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-information-blocks"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {

  const openButtons = document.querySelectorAll(".open-modal");
  const modals = document.querySelectorAll(".custom-modal");

  openButtons.forEach(btn => {
    btn.addEventListener("click", () => {
      const modalId = btn.dataset.modal;
      const modal = document.getElementById(modalId);

      if (modal) {
        modal.classList.add("active");
        document.body.style.overflow = "hidden";
      }
    });
  });
 modals.forEach(modal => {
 modal.querySelector(".modal-close").addEventListener("click", () => closeModal(modal));

    modal.querySelector(".custom-modal-overlay").addEventListener("click", () => closeModal(modal));
  });
  document.addEventListener("keydown", e => {
    if (e.key === "Escape") {
      modals.forEach(modal => closeModal(modal));
    }
  });

  function closeModal(modal) {
    modal.classList.remove("active");
    document.body.style.overflow = "";
  }

});
document.addEventListener("DOMContentLoaded", function () {
  var modals = document.getElementById("popup-modals");
  var btns = document.getElementById("popup-btns");
  var spans = document.querySelector(".closes");

  btns.onclick = function () {
    modals.style.display = "block";
  };

  spans.onclick = function () {
    modals.style.display = "none";
  };

  window.onclick = function (event) {
    if (event.target == modals) {
      modals.style.display = "none";
    }
  };
});
  } catch(e) { console.error(e); }
})();

})();
